/* unplugin-vue-components disabled */import script from "./UsersList.vue?vue&type=script&lang=ts&setup=true"
export * from "./UsersList.vue?vue&type=script&lang=ts&setup=true"

import "./UsersList.vue?vue&type=style&index=0&id=195d6ff1&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-195d6ff1"]])

export default __exports__